<template>

  <div
    class="container"
    @mouseenter="active=true"
    @mouseleave="active=false"
  >

    <transition name="fade">
      <span
        v-show=active
        class="thumb-title"
      >
        {{ workpost.title }}
      </span>
    </transition>

    <div class='thumb-grad'>
    </div>
 
    <transition name="fade" mode="out-in">

      <img
        v-if=!workpost.thumbnail
        :key=1
        v-on:load="onLoaded" v-show="loaded"
        class="thm-media"
        v-bind:src="dummyimage"
      >

      <video
        v-if=FileIsVideo(workpost.thumbnail)
        :key=2
        @canplay="onLoaded"
        v-show="loaded"
        class='thm-media'
        :preload=true
        playsinline
        autoplay
        muted
        loop
        v-bind:src="workpost.thumbnail"
      >
      </video>
    
      <img
        v-else
        :key=3
        v-on:load="onLoaded" v-show="loaded"
        class="thm-media"
        v-bind:src="workpost.thumbnail"
      >
    </transition>


  </div>

</template>

<script>

export default {
  data() {
    return {
      active: false,
      loaded: false,
      vimeoOptions: {
          responsive: true,
      },
      dummyimage: "https://dummyimage.com/hd1080"
    }
  },
  props: {
      workpost : Object,
  },
  methods: {
    onLoaded() {
      this.loaded = true;
    },
    mouseOver: function(){
      this.active = !this.active;   
    },
    FileIsVideo(file){
        if (file === null) {
          return false
        }

        let upload = file
               
        // check extension
        let video_extensions = ['mp4']

        // links to aws now are presigned so there is a lot of text after the '?'
        // so split there to get the actual file path
        let file_url = upload.split("?")[0]

        // if file extension is a video
        if (video_extensions.includes(file_url.split(".").pop().toLowerCase())) {
            return true
        }
        else {
            return false
        }
    }
  },
}
</script>

<style lang="scss" scoped>

@import '~bulma/sass/utilities/_all';
@import '../assets/sass/main.scss';

  .thm-media {
    box-shadow: 0px 2px 8px -1px #00000003;
    border-radius: 2px;
    
    // filter: brightness(100%);
    transition: 1s ease-in-out;
    
    &:hover {
      // filter: brightness(105%);
      // transform: scale(1.1);
    }
  }
  
  .thumb-grad {
    background: black;
    position: absolute;
    z-index: 10; // keep below navbar
    // width: calc(100% - 1rem); // calc matches column padding (x2)
    // height: calc(100% - 1rem);
    width: 100%; // calc matches column padding (x2)
    height: 100%;
    mask-image: linear-gradient(to bottom, rgba(255,0,0,0) 50%, rgba(255,0,0,1) 200%);
    border-radius: 2px;

    opacity: 0;
    transition: .5s ease-in-out;

    &:hover {
      opacity: 1;
    }
  }
  .fade-enter-active {
    transition: all .2s ease-in;
  }
  .fade-leave-active {
    transition: all 2s ease;
  }

  .thumb-title {
    position: absolute;
    z-index: 20; // above grad
    font-size: 2rem;
    text-decoration: underline;
    color: $white;
    bottom: 2.4rem;
    left: 1rem;
    text-underline-position: under;
    // top: 1rem;
    // left: 0%;
    // right: 0%;
    // text-align: center;
  }

  @include mobile {
    .thm-media {
      width: 100%;
    }
    .workpost {
      height: auto; // without a set height, inital scrolling doesnt end in the correct pos
    }

  }

</style>
